// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.875}
      d="M4.1665 4.16699C2.78579 4.16699 1.6665 5.28628 1.6665 6.66699V13.3337C1.6665 14.7144 2.78579 15.8337 4.1665 15.8337H11.6665C12.7937 15.8337 13.7467 15.0876 14.0586 14.0624M14.1665 10.0003L17.1951 6.97173C17.5521 6.61475 17.7306 6.43626 17.8838 6.4242C18.0168 6.41373 18.1467 6.46756 18.2333 6.56898C18.3332 6.68586 18.3332 6.93829 18.3332 7.44313V12.5575C18.3332 13.0624 18.3332 13.3148 18.2333 13.4317C18.1467 13.5331 18.0168 13.5869 17.8838 13.5765C17.7306 13.5644 17.5521 13.3859 17.1951 13.0289L14.1665 10.0003ZM14.1665 10.0003V8.16699C14.1665 6.76686 14.1665 6.0668 13.894 5.53202C13.6543 5.06161 13.2719 4.67916 12.8015 4.43948C12.2667 4.16699 11.5666 4.16699 10.1665 4.16699H7.9165M1.6665 1.66699L18.3332 18.3337"
    />
  </svg>
);
const IconVideoRecorderOff = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconVideoRecorderOff;
